import { Api } from '@/api/api';
import { User } from '@/models/user';
import { CreateUserRequest } from '@/models/create-user-request';

export class UserApi extends Api {
    public async fetchAsync(): Promise<Array<User>> {
        return await this.getAsync<Array<User>>('v2/user');
    }
    public async fetchByIdAsync(id: number): Promise<User> {
        return await this.getAsync<User>(`v2/user/${id}`);
    }
    public async fetchMeAsync(): Promise<User> {
        return await this.getAsync<User>('v2/user/me');
    }
    public async createAsync(user: CreateUserRequest): Promise<void> {
        return await this.postAsync<void>(`v2/user`, user);
    }
    public async grantUserRoleAsync(id: number, role: string): Promise<void> {
        await this.postAsync<void>(`v2/user/${id}/role`, { role: role });
    }
    public async revokeUserRoleAsync(id: number, role: string): Promise<void> {
        await this.deleteAsync<void>(`v2/user/${id}/role/${role}`);
    }
}
